import * as React from 'react';
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "../../Parts/Button";
import EditAccessoryPopup from "../NewItems/EditAccessoryPopup";
import { deleteQuoteAccessory, updateQuoteAccessory } from '../../Store/entities/accessories';
import { UsePortalDispatch } from '../../Store';

type AccessoryActionsProps = {
	quoteId: number;
	lineNumber: number;
};

const AccessoryAction = ({ quoteId, lineNumber }: AccessoryActionsProps) => {
	const dispatch = UsePortalDispatch();
	
	const updateAccessoryQuantity = (quantity: number) => {
		if (quantity === 0) {
			dispatch(deleteQuoteAccessory({ quoteId, lineNumber }));
		} else {
			dispatch(updateQuoteAccessory({ quoteId, lineNumber, quantity, parms: [] }));
		}
	};

	return (
		<div className='w-75 m-auto'>
			<Button
				title="Delete"
				color="light"
				size="sm"
				fullWidth
				onClick={() => {
					updateAccessoryQuantity(0);
				}}
			>
				<FontAwesomeIcon icon={faTrashAlt} />
			</Button>
			<EditAccessoryPopup key={`acc-${lineNumber}-${quoteId}`} lineNumber={lineNumber} quoteId={quoteId} />
		</div>
	);
};

export default AccessoryAction;
